import { Bubble, Props as BubbleProps } from './Bubble';
import Image from 'next/image';
import { useOfficialTellerSettings } from '@raysee/hooks';

interface TellersBubbleProps extends BubbleProps {
  selectedTellerId?: string;
}

export const TellersBubble = (props: TellersBubbleProps) => {
  const [settings] = useOfficialTellerSettings();
  const selectedTeller = props.message.tellers?.find(
    (teller) => teller.id === props.selectedTellerId,
  );
  let displayTellers = selectedTeller ? [selectedTeller] : props.message.tellers ?? [];

  const TellerCardImage = (props) => {
    const setting = settings?.find(
      (setting) =>
        !setting.disabled && !!setting.counselCard && setting.tellerId === props.tellerId,
    );
    return setting ? (
      <Image src={setting.counselCard.imageUrl} alt="" width={225} height={361} />
    ) : null;
  };

  return (
    <div>
      <Bubble {...props}>
        <div className="rounded-2xl border bg-white px-4 py-3 drop-shadow-sm">
          <p>{props.message.text}</p>
        </div>
      </Bubble>
      <div className="mb-4">
        <div className={`flex overflow-x-auto pb-5 ${selectedTeller && 'justify-center'}`}>
          {displayTellers.map((teller, i) => {
            if (teller.id === 'eauTtp3pcyZ0YrCG7ekov8XNOsj2') return;

            return (
              <div
                className="relative mx-1 flex h-96 flex-none flex-col items-center rounded-3xl py-4 drop-shadow-xl first:pl-4 last:pr-4"
                key={i}
              >
                <TellerCardImage tellerId={teller.id} />
                {selectedTeller ? (
                  <div className="bg-button-primary absolute top-[149px] mt-44 w-[200px] rounded-md  text-sm font-bold text-white opacity-30">
                    <p className="p-2 text-center text-white">鑑定してもらう</p>
                  </div>
                ) : (
                  <button
                    className="bg-button-primary absolute top-[149px] mt-44 w-[200px] rounded-md text-sm font-bold text-white"
                    onClick={() => props.onSend(teller.name + '先生#' + teller.id)}
                  >
                    <p className="p-2 text-center text-white">鑑定してもらう</p>
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
